import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { IReason } from '../../data/reason';

@Component({
  selector: 'app-list-reasons',
  templateUrl: './list-reasons.component.html',
  styleUrls: ['./list-reasons.component.scss']
})
export class ListReasonsComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() reasons: IReason[] = []
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() mudouPagina = new EventEmitter<number>();
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
      paginaSelecionada: 0,
      tamanhoPagina: 10,
      totalPaginas: 0,
      itensTotal: 0
    };

  constructor() { }

}
